/** 榜单读取：/board（top 榜）与 /rank-snapshot（个人位次），均读离线快照。 */
import type { BoardEntry, RankResult } from '../core/types';
import type { BoardMode } from '../core/types';
import { API_BASE } from './api';

export interface BoardData {
  pending?: boolean;
  date: string;
  mode: BoardMode;
  region: string;
  generatedAt: string | null;
  total: number;
  top: BoardEntry[];
}

export type RankData =
  | { pending: true }
  | { unranked: true; generatedAt: string }
  | RankResult;

export async function fetchBoard(
  date: string,
  mode: BoardMode = 'daily',
  region = 'global',
): Promise<BoardData> {
  const r = await fetch(
    `${API_BASE}/board?date=${date}&mode=${mode}&region=${region}`,
  );
  if (!r.ok) throw new Error('board failed');
  return (await r.json()) as BoardData;
}

export async function fetchRank(
  date: string,
  token: string,
  mode: BoardMode = 'daily',
  region = 'global',
): Promise<RankData> {
  const r = await fetch(
    `${API_BASE}/rank-snapshot?date=${date}&mode=${mode}&region=${region}&token=${token}`,
  );
  if (!r.ok) throw new Error('rank failed');
  return (await r.json()) as RankData;
}
